export default "__VITE_ASSET__73756c97__"